// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".spinner[data-v-6857a4d7]{width:100%;background:#fff;display:flex;align-items:center;justify-content:center}.full[data-v-6857a4d7]{position:absolute;width:100%;height:100%;left:0;top:0;z-index:1}.icon[data-v-6857a4d7]{-webkit-animation:spin-data-v-6857a4d7 1s ease-out infinite;animation:spin-data-v-6857a4d7 1s ease-out infinite}@-webkit-keyframes spin-data-v-6857a4d7{to{transform:rotate(1turn) scale(1.5)}}@keyframes spin-data-v-6857a4d7{to{transform:rotate(1turn) scale(1.5)}}", ""]);
// Exports
module.exports = exports;
